/**
 * Normalizza il JSON restituito da get_property_preview nella forma che la
 * pagina di anteprima si aspetta, la stessa che useProperty produce per la
 * scheda pubblica: immagini già ordinate, punti di forza in ordine, planimetria
 * risolta a una URL sola.
 */

import { PLACEHOLDER_IMAGE } from './imageProxy';
import type { PropertyPrice } from './propertyPrice';

export interface PreviewProperty extends PropertyPrice {
  [key: string]: any;
  images: string[];
  primaryImage: string;
  strengths: any[];
  features: any[];
  planimetria: string | null;
}

export const mapPreviewProperty = (raw: any): PreviewProperty | null => {
  if (!raw || typeof raw !== 'object') return null;

  const images = [...(raw.property_images || [])].sort((a: any, b: any) => {
    if (a.is_primary && !b.is_primary) return -1;
    if (!a.is_primary && b.is_primary) return 1;
    if (a.position != null && b.position != null) return a.position - b.position;
    return 0;
  });

  const strengths = [...(raw.property_strengths || [])].sort(
    (a: any, b: any) => (a.order_index ?? 0) - (b.order_index ?? 0)
  );

  return {
    ...raw,
    images: images.map((image: any) => image.url).filter(Boolean),
    primaryImage: images.find((image: any) => image.is_primary)?.url || images[0]?.url || PLACEHOLDER_IMAGE,
    strengths,
    features: raw.features || [],
    planimetria: raw.planimetria || null,
  };
};
